import styled from "styled-components";
import { Button, Card, Title, useActions } from "@introist/react-foundation/v2";
import { CSSProperties, ReactNode } from "react";
import { NakedButton } from "../../foundation";

const StyledUnsavedChanges = styled(Card)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--spacing-large);
  background-color: var(--palette-foreground-default);
  padding: var(--spacing-small);
  padding-left: var(--spacing-medium);
  box-sizing: border-box;

  > h5 {
    color: var(--palette-surface-default);
  }

  > button {
    box-shadow: none;
  }
`;

export const UnsavedChanges = ({
  onSave,
  show,
  style,
  saveTitle = "Save",
  secondary,
  onDiscard
}: {
  onSave: () => Promise<unknown>;
  onDiscard?: () => unknown;
  show: boolean;
  style?: CSSProperties;
  saveTitle?: string;
  secondary?: ReactNode;
}) => {
  const { onConfirmAction } = useActions();

  const discard = onConfirmAction(onDiscard!, {
    title: "Discard changes",
    description: "Are you sure you want to discard your changes?",
    confirmTitle: "Discard"
  });

  if (!show) return null;
  return (
    <StyledUnsavedChanges mode="dark" style={style}>
      <Title>Unsaved changes</Title>
      <Button onClickWithLoading={onSave}>{saveTitle}</Button>
      {onDiscard && (
        <NakedButton onClick={discard}>
          <Title color="white">Discard</Title>
        </NakedButton>
      )}
      {secondary}
    </StyledUnsavedChanges>
  );
};
